import React from 'react';
import { RouteComponentProps } from '@reach/router';
import FullPage from '../../layouts/FullPage';

// TODO: Import components

interface IProjectCreateConceptPageProps extends RouteComponentProps { }

interface IState { }

class ProjectCreateConceptPage extends React.Component<IProjectCreateConceptPageProps, IState> {
    // Define the constructor for the project create concept page
    constructor (props: IProjectCreateConceptPageProps) {
        // Pull in parent props
        super(props);
    }

    // TODO: When the component mounts
    componentDidMount () {
    }

    // Render the TSX for the project create concept container
    render () {
        return (
            <FullPage>
                Project Create Concept page
            </FullPage>
        );
    }
}

export default ProjectCreateConceptPage;
